import { render, staticRenderFns } from "./RsaAccettazioneEditPage.vue?vue&type=template&id=fa344654"
import script from "./RsaAccettazioneEditPage.vue?vue&type=script&lang=js"
export * from "./RsaAccettazioneEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports